import * as React from 'react';
import Box from '@mui/material/Box';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import PageContainer from './PageContainer';
import EmployeeInstallmentsTable from './EmployeeInstallmentsTable';

export default function Payments() {
  const { user } = useAuth();
  const { t } = useLanguage();

  if (!user) {
    return null;
  }

  return (
    <PageContainer
      breadcrumbs={[
        { title: t('sidebar.payments') || 'Payments' },
      ]}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%' }}>
        <EmployeeInstallmentsTable showEmployeeFilter />
      </Box>
    </PageContainer>
  );
}

